import { Delete, Public, Warning } from '@mui/icons-material';
import { IconButton, Typography, Card, Tooltip } from '@mui/material';
import { Box} from '@mui/system';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { Filler } from '../../common/components/Filler';
import { FlexColumn } from '../../common/FlexColumn';
import { FlexRow } from '../../common/FlexRow';
import { useAssets } from '../useAssets';
import { DuplicateButton } from './DuplicateButton';

type AssetPreviewProps = {
  id: string;
  onDelete: (assetId: string) => void;
};
export const AssetPreview = (props: AssetPreviewProps) => {
  const history = useHistory();
  const assets = useAssets();

  const goto = () => {
    // Ensure we navigate in a way that triggers React Router update consistently
    history.push(`/asset/${props.id}`);
  };

  const asset = assets.getAsset(props.id);

  return (
    <Card sx={{ width: '260px', m: 1 }}>
      <FlexColumn p={1}>
        <FlexRow>
          <Typography onClick={goto}>{asset?.name.value || props.id}</Typography>
          <Filler />
          <DuplicateButton asset={asset}/>
          <IconButton
            sx={{ position: 'relative' }}
            onClick={() => {
              props.onDelete(props.id);
            }}
          >
            <Delete sx={{ position: 'absolute', top: 0, right: 0 }} />
          </IconButton>
        </FlexRow>
        <Box sx={{ position: 'relative' }} onClick={goto}>
          {asset.thumbnailImage}
          {asset?.modifiedSinceLastPublish ? (
            <Tooltip title={'Modified but NOT Published'}>
              <Warning sx={{ color: 'orange', position: 'absolute', bottom: 0, right: 0 }} />
            </Tooltip>
          ) : (
            asset?.published?.value && (
              <Tooltip title={'Published'}>
                <Public sx={{ color: 'deepskyblue', position: 'absolute', bottom: 0, right: 0 }} />
              </Tooltip>
            )
          )}
          { (() => {
            const check = asset?.checkInteraction();
            return !check.isCorrect && (
              <Tooltip title={`Interaction misconfigured: ${check.categoryName} enforces ${check.categoryInteraction} interaction, but asset has ${check.assetInteraction} interaction`}>
                <Warning sx={{ color: 'chocolate', position: 'absolute', bottom: 0, right: 30 }} />
              </Tooltip>
            );
          })() }
        </Box>
      </FlexColumn>
    </Card>
  );
};
